import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import a4 from "../../../../assets/edgemarketing/a4.png"

import '../edgemarketing.css'


function Styleguide() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#181818",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
       <Image src={a4} alt='a3' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </Container>
    
     
    
  )
}

export default Styleguide
